import { createContext, type Dispatch, type PropsWithChildren, type SetStateAction, useMemo, useState } from 'react'
import { useIsMobileVariant } from '../../../theme/hooks/use-is-mobile-variant'
import { type CardProps } from '../CardInternal'

export type CardState = {
  isDense?: CardProps['isDense']

  hasHeader: boolean

  /**
   * This only has influence on non mobile variants
   *
   * @deprecated for new compliance with DE we are not allowed to use this anymore
   * visually we removed these, and will clean it up in next release
   */
  hasDividerTop?: boolean

  /**
   * This only has influence on non mobile variants
   *
   * @deprecated for new compliance with DE we are not allowed to use this anymore
   * visually we removed these, and will clean it up in next release
   */
  hasDividerBottom?: boolean

  isMobile: boolean
}

type CardActions = {
  setHasHeader: Dispatch<SetStateAction<boolean>>
}

export type CardContextProps = CardState & CardActions

export const defaultValue = {}

export const CardContext = createContext<CardContextProps>(defaultValue as CardContextProps)

type CardProviderProps = PropsWithChildren<Pick<CardState, 'isDense'>>

export function CardProvider({ children, isDense = false }: CardProviderProps) {
  const isMobile = useIsMobileVariant()
  const [hasHeader, setHasHeader] = useState(false)

  const value = useMemo(
    (): CardContextProps => ({
      isDense,
      hasHeader,
      setHasHeader,
      isMobile,
    }),
    [isDense, hasHeader, isMobile]
  )

  return <CardContext.Provider value={value}>{children}</CardContext.Provider>
}
